module.exports = __webpack_public_path__ + "res/Roboto-BoldCondensed-webfont.woff?9b9d5dc09b0e8b8368113062937169f0";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BoldCondensed-webfont.woff
// module id = 43
// module chunks = 0